<template>
<div :class="{'ma-3':$vuetify.breakpoint.smAndUp}">
    <v-card class="pa-1">
        <v-row no-gutters align="center">
            <v-col cols="12" md="6">
                <div class="d-flex align-center">
                    <v-menu offset-y>
                        <template v-slot:activator="{ on }">
                            <v-btn color="primary" text icon v-on="on">
                                <v-tooltip top>
                                    <template v-slot:activator="{ on }">
                                        <v-icon v-on="on">sync</v-icon>
                                    </template>
                                    <span>Sync</span>
                                </v-tooltip>
                            </v-btn>
                        </template>
                        <v-list>
                            <v-list-item @click="sync_data = 'static', dialog_sync = true">
                                <v-list-item-title>{{ $t('sheet.sync.static') }}</v-list-item-title>
                            </v-list-item>
                            <v-list-item @click="sync_data = 'inventory', dialog_sync = true">
                                <v-list-item-title>{{ $t('sheet.sync.inventory') }}</v-list-item-title>
                            </v-list-item>
                        </v-list>
                    </v-menu>

                 <template v-if="$vuetify.breakpoint.smAndUp">                     
                    <v-icon color="primary" @click="$emit('prevPeriod')">keyboard_arrow_left</v-icon>
                    <v-menu transition="scale-transition" offset-y v-model="menu_period_start" :close-on-content-click="false">
                        <template v-slot:activator="{ on }">
                            <v-text-field v-on="on" :class="{'im-select':$vuetify.breakpoint.xs}" flat solo readonly :placeholder="$t('sheet.from')" v-model="c_period_start_time" @input="menu_period_stop = true" hide-details style="max-width: 150px"></v-text-field>
                        </template>
                        <v-date-picker v-model="c_period_start" :min="today" no-title @input="menu_period_start = false, menu_period_stop = true" width="265" :locale="$vuetify.lang.current"></v-date-picker>
                    </v-menu>
                    <v-icon small class="mx-1">arrow_forward</v-icon>
                    <v-menu transition="scale-transition" offset-y v-model="menu_period_stop" :close-on-content-click="false">
                        <template v-slot:activator="{ on }">
                            <v-text-field v-on="on" :class="{'im-select':$vuetify.breakpoint.xs}" flat solo readonly :placeholder="$t('sheet.until')" v-model="c_period_stop_time" @input="refresh();menu_period_stop = false" hide-details style="max-width: 150px"></v-text-field>
                        </template>
                        <v-date-picker v-model="c_period_stop" :min="c_period_start" show-current="2013-07" no-title @input="menu_period_stop = false" width="265" :locale="$vuetify.lang.current"></v-date-picker>
                    </v-menu>
                    <v-icon color="primary" text icon @click="$emit('nextPeriod')">keyboard_arrow_right</v-icon>
                 </template>

                 <template v-else>
                      <v-icon color="primary" @click="prevDay()">keyboard_arrow_left</v-icon>
                        <v-menu transition="scale-transition" offset-y  close-on-content-click>
                            <template v-slot:activator="{ on }">
                                <v-text-field v-on="on" class="" flat solo readonly :placeholder="$t('sheet.from')" v-model="c_period_start_time"  hide-details style="max-width: 150px"></v-text-field>
                            </template>
                            <v-date-picker v-model="c_day_start" :min="today" no-title  width="265" :locale="$vuetify.lang.current"></v-date-picker>
                        </v-menu>
                    <v-icon color="primary" text icon @click="nextDay()">keyboard_arrow_right</v-icon>
                 </template>
                   
                </div>
            </v-col>
            <v-col cols="12" md="6">
                <div class="d-flex align-center justify-end flex-wrap">
                    <v-btn-toggle slot="button" class="group-btn px-2" mandatory v-model="net_price">
                        <v-btn color="blue" small :value="false">{{ $t('sheet.selection.price.gross') }}</v-btn>
                        <v-btn color="orange" small :value="true">{{ $t('sheet.selection.price.net') }}</v-btn>
                    </v-btn-toggle>
                    <v-menu v-if="true" class="px-2" v-model="select" :close-on-content-click="false" min-width="550px" offset-y content-class="">
                        <template v-slot:activator="{ on }">
                            <div class="" v-on="on" style="cursor:pointer">
                                {{ $tc('sheet.selection.text.room_type', rooms.length, {rooms: rooms.length})}}
                                <span v-if="net_price">
                                    {{ $tc('sheet.selection.text.rate_plan', ids_net.length, {plans: ids_net.length})}}
                                </span>
                                <span v-else>
                                    {{ $tc('sheet.selection.text.rate_plan', ids_gross.length, {plans: ids_gross.length})}}
                                </span>
                                <span>
                                    <v-icon>keyboard_arrow_down</v-icon>
                                </span>
                            </div>
                        </template>
                        <v-card>
                            <v-card-text>
                                <v-row>
                                    <v-col sm="6" cols="12">
                                        <div class="important">{{$t('sheet.selection.room_type')}}</div>

                                        <div v-for="room in room_types" :key="room.id" class="pa-1">
                                            <v-checkbox v-model="rooms" :value="room.id" :label="room.name" class="pa-0 ma-0 label-truncate" :disabled="room.close_out" hide-details>
                                                <template v-slot:label>
                                                    <div class="text-truncate" v-if="room.name">{{room.name}}</div>
                                                    <div class="text-truncate" v-else>{{$t('room_type_slug.' +room.slug)}}</div>
                                                </template>
                                            </v-checkbox>
                                            <div v-if="room.close_out" class="detail pl-5">
                                                Camera inactiva
                                            </div>
                                        </div>
                                    </v-col>
                                    <v-col sm="6" cols="12">
                                        <div class="important">{{$t('sheet.selection.rate_plan')}}</div>
                                        <div v-if="net_price">
                                            <template v-for="rate_plan in rate_plans_net">
                                                <v-checkbox v-model="ids_net" :value="rate_plan.id" :label="rate_plan.name" class="pa-0 mt-1 label-truncate" :disabled="rate_plan.stop_sell" hide-details />
                                                <div v-if="rate_plan.stop_sell" class="detail">
                                                    Plan inactiv
                                                </div>
                                            </template>
                                        </div>
                                        <div v-else>
                                            <template v-for="rate_plan in rate_plans_gross">
                                                <v-checkbox v-model="ids_gross" :value="rate_plan.id" :label="rate_plan.name" class="pa-0 mt-1 label-truncate" :disabled="rate_plan.stop_sell" hide-details />
                                                <div v-if="rate_plan.stop_sell" class="detail pl-5">
                                                    Plan inactiv
                                                </div>
                                            </template>
                                        </div>
                                    </v-col>
                                </v-row>
                            </v-card-text>
                        </v-card>
                    </v-menu>
                </div>
            </v-col>
        </v-row>
    </v-card>

    <!-- dialog sync -->
    <v-dialog v-model="dialog_sync" max-width="460">
        <v-card flat>
            <v-card-text>
                {{ $t('sheet.dialod_sync.message') }}
            </v-card-text>
            <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="green" dark @click="sync()">
                    {{ $t('button.yes') }}
                </v-btn>
                <v-btn color="red" dark @click="sync_data = null, dialog_sync= false">
                    {{ $t('button.no') }}
                </v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
    <!--./ dialog sync -->
</div>
</template>

<script>
import {
    mapActions
} from 'vuex';


export default {
    components: {

    },
    name: `sheet-selection-bar`,

    props: {
        hotel_id: [Number, String],
        period_start: [String],
        period_stop: [String]
    },
    data() {
        return {
            //sync
            dialog_sync: false,
            sync_data: null,

            net_price: false,
            mobile_picker: null,
            select: false,
            menu_period_start: null,
            menu_period_stop: null,

            rooms: [],
            room_types: [],
            room_types_selections: [],
            rate_plans: [],
            rate_plans_net: [],
            ids_net: [],
            rate_plans_gross: [],
            ids_gross: [],
            rate_plans_selected: [],
            previous_plans_selected: [],
            days: [],

            today: new Date()
                .toISOString()
                .substr(0, 10),
        }
    },
    watch: {
        hotel_id: {
            handler() {
                this.ids_net = [];
                this.ids_gross = [];
                this.rooms = [];
                this.getRoomsTypes();
                this.getRatePlans();
            }
        },
        rooms: {
            handler() {
                this.$emit('updateRooms', this.rooms)
            }
        },
        ids_net: {
            handler() {
                let value = this.ids_net.concat(this.ids_gross)
                this.$emit('updateRatePlans', value)
            }
        },
        ids_gross: {
            handler() {
                let value = this.ids_net.concat(this.ids_gross)
                this.$emit('updateRatePlans', value)
            }
        },
        net_price: {
            handler() {
                this.$emit('net_price', this.net_price)
            }
        }
    },

    computed: {
        c_day_start: {
            get: function () {
                return this.period_start
            },
            set: function (newValue) {
                this.$emit("update:period_start", newValue);
                this.$emit("update:period_stop", newValue);
                this.$emit("refresh")
            }
        },
        c_period_start: {
            get: function () {
                return this.period_start
            },
            set: function (newValue) {
                this.$emit("update:period_start", newValue);
                this.$emit("update:period_stop", this.$moment(newValue)
                    .add(14, 'days')
                    .format('YYYY-MM-DD'));
            }
        },
        c_period_stop: {
            get: function () {
                return this.period_stop
            },
            set: function (newValue) {
                this.$emit("update:period_stop", newValue);
                this.$emit("refresh")
            }
        },
        c_day_start_time: {
            get: function () {
                return this.$moment(this.period_start).format('D MMM YYYY')
            },
            set: function (newValue) {
                
            }
        },
        c_period_start_time: {
            get: function () {
                return this.$moment(this.period_start).format('D MMM YYYY')
            },
            set: function (newValue) {
                
            }
        },
        c_period_stop_time: {
            get: function () {
                return this.$moment(this.period_stop).format('D MMM YYYY')
            },
            set: function (newValue) {
                
            }
        },

    },

    created() {
        this.getRoomsTypes();
        this.getRatePlans();
    },

    methods: {
        ...mapActions('alert', ['success', 'error']),

        sync() {
            if(!this.sync_data) {
                this.error('Ooops, something gone wrong');
                return
            }
            // setup query endpoint
            let secure = process.env.VUE_APP_HTTP_SECURE === 'true' ? 'https://' : 'http://';
            let endpoint = secure + process.env.VUE_APP_ENDPOINT_SERVICES_PROXY + '/api/services-new/console/v1/hotels/sync-' + this.sync_data;

            // setup query params
            let params = {
                hotel_id: this.hotel_id
            };
            this.$axios.post(endpoint, params)
                .then(response => {
                    this.success(this.$t('sheet.message_sync'));
                })
                .catch(error => {
                    console.log(error);
                    this.error('Ooops, something gone wrong');
                })
                .finally(() => {
                    this.sync_data = null;
                    this.dialog_sync = false;
                    this.refresh();
                });
        },

        getRatePlans() {
            if(!this.hotel_id) {
                return;
            }
            // prepare stamp & save current_stamp
            let stamp = Date.now();

            // setup query endpoint
            let secure = process.env.VUE_APP_HTTP_SECURE === "true" ? "https://" : "http://";
            let endpoint = secure + process.env.VUE_APP_ENDPOINT_SERVICES_PROXY + "/api/services-new/console/v1/rate-plans";

            // setup query params
            let params = {
                params: {
                    size: 50,
                    hotel_id: this.hotel_id,
                    stamp: stamp,
                }
            };

            return this.$axios.get(endpoint, params)
                .then(response => {
                    response.data.data.forEach(function (rate_plan, index) {
                        if(rate_plan.net_prices == false) {
                            this.rate_plans_gross.push(rate_plan);
                            if(!rate_plan.stop_sell) {
                                this.ids_gross.push(rate_plan.id);
                            }
                        }
                        if(rate_plan.net_prices == true && !rate_plan.stop_sell) {
                            this.rate_plans_net.push(rate_plan);
                            if(!rate_plan.stop_sell) {
                                this.ids_net.push(rate_plan.id);
                            }
                        }

                    }.bind(this))
                })
                .catch(error => {
                    console.log(error);
                })
                .finally(() => {});
        },

        getRoomsTypes() {
            if(!this.hotel_id) {
                return;
            }
            // prepare stamp & save current_stamp
            let stamp = Date.now();
            this.current_stamp = stamp;

            // setup query endpoint
            let secure = process.env.VUE_APP_HTTP_SECURE === "true" ? "https://" : "http://";
            let endpoint = secure + process.env.VUE_APP_ENDPOINT_SERVICES_PROXY + "/api/services-new/console/v1/room-types";

            // setup query params
            let params = {
                params: {
                    size: 50,
                    hotel_id: this.hotel_id,
                    stamp: stamp,
                }
            };

            this.$axios.get(endpoint, params)
                .then(response => {
                    this.room_types = response.data.data;
                    response.data.data.forEach(function (room, index) {
                        if(!room.close_out) {
                            this.room_types_selections.push(room);
                            if(this.rooms.indexOf(room.id) == -1) {
                                this.rooms.push(room.id)
                            }
                        }
                    }.bind(this))

                })
                .catch(error => {
                    console.log(error);
                })
                .finally(() => {});
        },
        nextDay(){
            let day = this.period_start;
            this.$emit("update:period_start", this.$moment(day)
                .add(1, 'days')
                .format('YYYY-MM-DD'));
            this.$emit("update:period_stop", this.$moment(day)
                .add(1, 'days')
                .format('YYYY-MM-DD'));
            this.$emit("refresh")
        },
        prevDay(){
            let day = this.period_start;
            this.$emit("update:period_start", this.$moment(day)
                .subtract(1, 'days')
                .format('YYYY-MM-DD'));
            this.$emit("update:period_stop", this.$moment(day)
                .subtract(1, 'days')
                .format('YYYY-MM-DD'));
            this.$emit("refresh")
        }
    },
}
</script>
<style lang="stylus">
.label-truncate
    &.v-input
        label
            width: inherit
            max-width: inherit
</style>
